import { motion } from "framer-motion"; // Import Framer Motion
import TitleBar from "../../TitleBar/TitleBarWithoutDivider";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import CustomLists from "@/components/elements/CustomLists/CustomLists";
import TitleWithContent from "../../titlewithcontent(without divider)/TitleWithContentWithoutDivider";

const TermsOfUse = () => {
  return (
    <div className="bg-custom-background pb-0 px-0 sm:px-1 2xl:px-40 xl:px-40 md:px-[3rem] ">
      <div className="pt-10">
        <motion.div
          initial={{ opacity: 0, scaleX: 0 }}
          animate={{ opacity: 1, scaleX: 1 }}
          transition={{ duration: 1 }}
        >
          <TitleBar title="Terms of Use" />
        </motion.div>
      </div>

      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { staggerChildren: 0.7, opacity: { duration: 1 } } },
        }}
      >
        <TitleWithContent title="Welcome">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="Welcome to the official website of Sheel Waterproofing Nepal Pvt. Ltd. ('Company,' 'we,' 'us,' or 'our'). By accessing or using our website, you agree to be bound by the following terms and conditions. If you do not agree to these Terms of Use, please do not use our site." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Use of the Website">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="You agree to use this website only for lawful purposes and in accordance with all applicable laws and regulations. You may not use this site:" />
            <CustomLists
            layout="stacked"
              items={[
                [
                  "To engage in any fraudulent, abusive, or illegal activity.",
                  "To infringe upon the intellectual property or proprietary rights of others.",
                  "To transmit any viruses, malware, or harmful code.",
                ],
              ]}
            />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Intellectual Property">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="All content on this website, including text, graphics, logos, images, and software, is the property of Sheel Waterproofing Nepal Pvt. Ltd. and is protected by copyright, trademark, and other applicable laws." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Disclaimer">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="This website and its content are provided on an 'as is' and 'as available' basis. We make no warranties, expressed or implied, regarding the accuracy, reliability, or availability of the information on this site." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Limitation of Liability">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="In no event shall Sheel Waterproofing Nepal Pvt. Ltd. be liable for any direct, indirect, incidental, or consequential damages resulting from your use of or inability to use this website." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="External Links">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="Our site may contain links to third-party websites. We are not responsible for the content or practices of any linked site and encourage you to review their terms and privacy policies." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Changes to Terms">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="We reserve the right to update or modify these Terms of Use at any time without prior notice. Continued use of the site constitutes acceptance of the modified terms." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Contact Us">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="For questions regarding these Terms of Use, please contact us at:" />
            <CustomLists 
              listStyle="none"
              layout="stacked"
              bullets={[["📧", "📞" ]]}
              items={[[ "sheelwaterproofing1@gmail.com", " 01-5384509" ]]}
            />
          </motion.div>
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default TermsOfUse;
